import React, { CSSProperties, useEffect, useState } from "react";
import {
  Avatar,
  Button,
  Divider,
  Empty,
  Form,
  Grid,
  Image,
  ImageViewer,
  Input,
  List,
  Popup,
  Space,
  TextArea,
  Toast,
} from "antd-mobile";
import { useParams } from "react-router-dom";

import { HeartFill, MessageFill } from "antd-mobile-icons";

import bg from "./assets/bg.png";

import { doLike, getTreeById, isLike, saveMessage } from "./service";
import { ITree } from "./typings.d";
import { getHdUser } from "../../services";
import storageUtil from "../../utils/storageUtil";
import { getQueryString } from "../../utils/httpUtil";

const wx = require("weixin-js-sdk");

const TreeDetailScreen: React.FC = React.memo((props) => {
  const [visible, setVisible] = useState(false);
  const [tree, setTree] = useState<ITree>();
  const [messageVisible, setMessageVisible] = useState(false);
  const [empty, setEmpty] = useState(false);
  const [user, setUser] = useState<{
    realName: string;
    mobilePhone: string;
    idcNumber: string;
  }>();
  const [like, setLike] = useState(false);
  const [likeCount, setLikeCount] = useState(0);

  const [url, setUrl] = useState("");

  const id = useParams().id;

  const [form] = Form.useForm();

  useEffect(() => {
    const init = async () => {
      if (id) {
        getTreeById(id)
          .then((data) => {
            console.log(data);
            setTree(data);
            setLikeCount(data.likeCount);
          })
          .catch((error) => {
            console.log(error);
            setEmpty(true);
          });
      }
      // 获取小程序带过来的token
      // const token = getQueryString("token");
      // alert(token);
      // if (token && token !== "null") {
      //   try {
      //     getHdUser(token)
      //       .then((data) => {
      //         if (data) {
      //           setUser(data);
      //         }
      //       })
      //       .catch((error) => {
      //         console.log(error);
      //       });
      //     storageUtil.setItem("MIN_PROGRAM_TOKEN", token);
      //   } catch (error) {
      //     Toast.show({
      //       icon: "fail",
      //       content: "获取用户信息失败",
      //     });
      //   }
      // }
    };
    init();
  }, [id]);

  useEffect(() => {
    // 如果存在用户信息，则判断用户是否对该树进行了点赞操作
    if (id && user && user.mobilePhone) {
      isLike(id, user.mobilePhone).then((data) => {
        if (data) {
          // 已点赞
          setLike(true);
        }
      });
    } else {
    }
  }, [id, user]);

  const rendPic = () => {
    if (tree?.plant?.files) {
      return (
        <Grid columns={3} gap={8}>
          {tree.plant.files.map((item, index) => {
            return (
              <Grid.Item>
                <Image
                  src={item.filePathFull ? item.filePathFull : ""}
                  style={pic}
                  onClick={() => {
                    showPic(item.filePathFull ? item.filePathFull : "");
                  }}
                />
              </Grid.Item>
            );
          })}
        </Grid>
      );
    }
  };

  const onFinish = (values: any) => {
    values.ancientId = id;
    values.type = 0;
    saveMessage(values).then((data) => {
      if (data) {
        Toast.show({
          icon: "success",
          content: "提交留言成功",
        });
        form.resetFields();
        setMessageVisible(false);
      } else {
        Toast.show({
          icon: "fail",
          content: "提交留言失败,请重试",
        });
        form.resetFields();
        setMessageVisible(false);
      }
    });
  };

  const renderMessage = () => {
    return (
      <Form
        form={form}
        onFinish={onFinish}
        footer={
          <Button block type="submit" color="primary" size="large">
            提交
          </Button>
        }
      >
        <Form.Item
          name="name"
          label="姓名"
          rules={[{ required: true, message: "姓名不能为空" }]}
        >
          <Input placeholder="请填写您的姓名" />
        </Form.Item>
        <Form.Item
          name="phone"
          label="电话"
          rules={[{ required: true, message: "联系电话不能为空" }]}
        >
          <Input placeholder="请填写您的联系电话" />
        </Form.Item>
        <Form.Item
          name="remark"
          label="内容"
          rules={[{ required: true, message: "留言内容不能为空" }]}
        >
          <TextArea placeholder="请填写您的建议与留言" rows={5} />
        </Form.Item>
      </Form>
    );
  };

  const showPic = (url: string) => {
    setUrl(url);
    setVisible(true);
  };

  const toLike = () => {
    // 判断当前用户是否已经登录，如果未登录，需要获取用户信息
    // if (id && user && user.realName && user.mobilePhone) {
    // 点赞操作
    doLike({
      // phone: '',
      ancientId: id ? id : '',
      // userName: '',
    })
      .then((data) => {
        if (data === 1) {
          Toast.show({
            icon: "success",
            content: "点赞成功",
          });
          setLikeCount(likeCount + 1);
          setLike(true);
        } else if (data === 0) {
          Toast.show({
            icon: "success",
            content: "取消点赞成功",
          });
          setLikeCount(likeCount - 1);
          setLike(false);
        }
      })
      .catch((error) => {
        Toast.show({
          icon: "fail",
          content: "操作失败",
        });
      });
    // } else {
    //   // 重新进行授权获取用户信息
    //   // toLogin();
    // }
  };

  const message = () => {
    // 判断当前用户是否已经登录，如果未登录，需要获取用户信息
    // if (id && user && user.realName && user.mobilePhone) {
    setMessageVisible(true);
    // form.setFieldsValue({ name: user.realName, phone: user.mobilePhone });
    // } else {
    // 重新进行授权获取用户信息
    // toLogin();
    // }
  };

  // const toLogin = () => {
  //   // 清空掉url中的token参数
  //   const url = window.location.href.replace("&token=null", "");
  //   const info = {
  //     faceScan: 1,
  //     legalSearch: 1,
  //     redirectType: 2,
  //     pathUrl: url,
  //   };
  //   let paramsInfo = encodeURIComponent(JSON.stringify(info));
  //   wx.miniProgram.redirectTo({
  //     url: `/pages/login/certLogin/index?info=${paramsInfo}`,
  //   });
  // };

  return (
    <div style={container}>
      {empty && (
        <Empty
          style={{ padding: "64px 0" }}
          imageStyle={{ width: 128 }}
          description="未查询到树木信息"
        />
      )}
      {!empty && (
        <div>
          <div style={topWrapper}>
            <Image
              src={tree?.plant?.picPathFull ? tree.plant.picPathFull : ""}
              // fit="fill"
              onClick={() => {
                showPic(tree?.plant?.picPathFull ? tree.plant.picPathFull : "");
              }}
            />
            <div style={{ ...topbg }}>
              <Image src={require("./assets/topbg.png")} fit="fill" />
            </div>
          </div>
          <div style={contentWrap}>
            <div style={king}>
              <Space>
                <span style={text}>{tree?.plant?.sectionName}</span>
                <span style={text}>{tree?.plant?.category}</span>
              </Space>
            </div>
            <div style={divider}></div>
            {/* <div style={title}>
              <span style={text}>{tree?.plant?.pinyin}</span>
            </div> */}
            <div style={title}>
              <span style={{ ...text, fontSize: 32 }}>{tree?.plant?.name}</span>
            </div>
            {/* <div style={title}>
              <span style={{ ...text }}>{`（${tree?.plant?.alias}）`}</span>
            </div> */}
            {/* <div style={title}>
              <span style={{ ...text }}>{tree?.plant?.scientific}</span>
            </div> */}
            <div style={divider}></div>
            <div style={picWrapper}>{rendPic()}</div>
            <Divider
              style={{
                color: "#939393",
                borderColor: "#e0e7ef",
                fontSize: 18,
                fontWeight: "bold",
              }}
            >
              形态特征
            </Divider>
            <div style={descWrapper}>
              {/* <div style={desc}>
                <span style={text}>生活型：</span>
                {tree?.plant?.typeName}
              </div> */}
              {tree?.plant?.plant && (
                <div style={desc}>
                  <span style={text}>株：</span>
                  {tree?.plant?.plant}
                </div>
              )}
              {tree?.plant?.stem && (
                <div style={desc}>
                  <span style={text}>茎：</span>
                  {tree?.plant?.stem}
                </div>
              )}

              {tree?.plant?.leaf && (
                <div style={desc}>
                  <span style={text}>叶：</span>
                  {tree?.plant?.leaf}
                </div>
              )}
              {tree?.plant?.flower && (
                <div style={desc}>
                  <span style={text}>花：</span>
                  {tree?.plant?.flower}
                </div>
              )}
              {tree?.plant?.fruit && (
                <div style={desc}>
                  <span style={text}>果：</span>
                  {tree?.plant?.fruit}
                </div>
              )}
              {tree?.plant?.seed && (
                <div style={desc}>
                  <span style={text}>种子：</span>
                  {tree?.plant?.seed}
                </div>
              )}
            </div>
            <Divider
              style={{
                color: "#939393",
                borderColor: "#e0e7ef",
                fontSize: 18,
                fontWeight: "bold",
              }}
            >
              生长习性
            </Divider>
            <div style={descWrapper}>
              {tree?.plant?.proInland && (
                <div style={desc}>
                  <span style={text}>国内产地：</span>
                  {tree?.plant?.proInland}
                </div>
              )}
              {tree?.plant?.proForeign && (
                <div style={desc}>
                  <span style={text}>国外分布：</span>
                  {tree?.plant?.proForeign}
                </div>
              )}
              {tree?.plant?.growingEnvironment && (
                <div style={desc}>
                  <span style={text}>生长习性：</span>
                  {tree?.plant?.growingEnvironment}
                </div>
              )}
              {tree?.plant?.altitude && (
                <div style={desc}>
                  <span style={text}>海拔：</span>
                  {tree?.plant?.altitude}
                </div>
              )}
              {tree?.plant?.phenologicalPeriod && (
                <div style={desc}>
                  <span style={text}>物候期：</span>
                  {tree?.plant?.phenologicalPeriod}
                </div>
              )}
            </div>
            <Divider
              style={{
                color: "#939393",
                borderColor: "#e0e7ef",
                fontSize: 18,
                fontWeight: "bold",
              }}
            >
              园林用途
            </Divider>
            <div style={descWrapper}>
              {tree?.plant?.economicValue && (
                <div style={desc}>
                  <span style={text}>园林用途：</span>
                  {tree?.plant?.economicValue}
                </div>
              )}
            </div>
            <Divider
              style={{
                color: "#939393",
                borderColor: "#e0e7ef",
                fontSize: 18,
                fontWeight: "bold",
              }}
            >
              基本信息
            </Divider>
            <div style={descWrapper}>
              {tree?.placeName && (
                <div style={desc}>
                  <span style={text}>位置：</span>
                  {tree?.placeName}
                </div>
              )}
              {/* <Grid columns={2} gap={8}>
                {tree?.longitude && (
                  <Grid.Item>
                    <div style={desc}>
                      <span style={text}>经度：</span>
                      {tree?.longitude}
                    </div>
                  </Grid.Item>
                )}
                {tree?.latitude && (
                  <Grid.Item>
                    <div style={desc}>
                      <span style={text}>纬度：</span>
                      {tree?.latitude}
                    </div>
                  </Grid.Item>
                )}
              </Grid> */}
              <Grid columns={2} gap={8}>
                {tree?.typeName && (
                  <Grid.Item>
                    <div style={desc}>
                      <span style={text}>树木类型：</span>
                      {tree?.typeName}
                    </div>
                  </Grid.Item>
                )}
                {/* {tree?.chest && (
                  <Grid.Item>
                    <div style={desc}>
                      <span style={text}>胸径(cm)：</span>
                      {tree?.chest}
                    </div>
                  </Grid.Item>
                )} */}
              </Grid>
              {tree?.ownershipUnit && (
                <div style={desc}>
                  <span style={text}>权属单位：</span>
                  {tree?.ownershipUnit}
                </div>
              )}
              {tree?.manageCompany && (
                <div style={desc}>
                  <span style={text}>管理单位：</span>
                  {tree?.manageCompany}
                </div>
              )}
              {tree?.companyPhone && (
                <div style={desc}>
                  <span style={text}>联系电话：</span>
                  {tree?.companyPhone}
                </div>
              )}
              {tree?.managementUnitName && (
                <div style={desc}>
                  <span style={text}>养护单位：</span>
                  {tree?.managementUnitName}
                </div>
              )}
              {tree?.caretaker && (
                <div style={desc}>
                  <span style={text}>管护人：</span>
                  {tree?.caretaker}
                </div>
              )}
              {tree?.linkPhone && (
                <div style={desc}>
                  <span style={text}>联系电话：</span>
                  {tree?.linkPhone}
                </div>
              )}
              {tree?.number && (
                <div style={desc}>
                  <span style={text}>树牌号：</span>
                  {tree?.number}
                </div>
              )}
              {/* <div style={desc}>
                <span style={text}>管养日志：</span>
              </div> */}
            </div>
            {/* <Divider
              style={{
                color: "#939393",
                borderColor: "#e0e7ef",
                fontSize: 18,
                fontWeight: "bold",
              }}
            >
              网友评论
            </Divider>
            <div>
              {tree?.comments?.length !== 0 &&
                tree?.comments?.map((item) => (
                  <List>
                    <List.Item
                      prefix={<Avatar src="" />}
                      description={item.remark}
                    >
                      {item.name}
                    </List.Item>
                  </List>
                ))}
              {!tree?.comments?.length && <Empty description="暂无评论..." />}
            </div> */}
            <Divider
              style={{
                color: "#939393",
                borderColor: "#e0e7ef",
                fontSize: 18,
                fontWeight: "bold",
                marginBottom: 60,
              }}
            >
              广州市海珠区园林绿化所
            </Divider>
          </div>
          <ImageViewer.Multi
            images={[url]}
            visible={visible}
            onClose={() => {
              setVisible(false);
            }}
          />
          <div style={likeWrapper} onClick={toLike}>
            {like && (
              <>
                <HeartFill style={{ fontSize: 36, color: "#fb4470" }} />
                {likeCount}
              </>
            )}
            {!like && (
              <>
                <HeartFill style={{ fontSize: 36, color: "#dbdbdb" }} />
                {likeCount}
              </>
            )}
          </div>
          <div style={messageWrapper} onClick={message}>
            <MessageFill style={{ fontSize: 36, color: "#95ec69" }} />
            留言
          </div>
          <Popup
            visible={messageVisible}
            onMaskClick={() => {
              setMessageVisible(false);
            }}
            bodyStyle={{
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              minHeight: "40vh",
            }}
          >
            {renderMessage()}
          </Popup>
        </div>
      )}
    </div>
  );
});

const container: CSSProperties = {};

const topWrapper: CSSProperties = {
  backgroundColor: "#e2eefa",
  position: "relative",
  width: "100%",
};

const topbg: CSSProperties = {
  position: "absolute",
  bottom: 0,
  width: "100%",
};

const contentWrap: CSSProperties = {
  backgroundImage: "url(" + bg + ")",
  backgroundRepeat: "repeat-x",
};
const king: CSSProperties = {
  height: 46,
  textAlign: "center",
  justifyContent: "center",
};

const title: CSSProperties = {
  display: "flex",
  height: 42,
  alignItems: "center",
  justifyContent: "center",
};

const text: CSSProperties = {
  fontSize: 16,
  fontWeight: "bold",
  color: "#c7a005",
};

const picWrapper: CSSProperties = {
  display: "flex",
  padding: 8,
  alignItems: "center",
};

const pic: CSSProperties = {
  borderRadius: 4,
};

const descWrapper: CSSProperties = {
  paddingLeft: 16,
  lineHeight: 2,
  fontSize: 18,
};

const desc: CSSProperties = {
  marginBottom: 4,
  whiteSpace: "pre-line",
};

const divider: CSSProperties = {
  height: 4,
  backgroundColor: "#cbd6e2",
};

const likeWrapper: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  position: "fixed",
  top: 120,
  right: 20,
  color: "var(--adm-color-weak)",
};

const messageWrapper: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  position: "fixed",
  top: 200,
  right: 20,
  color: "#95ec69",
};

export default TreeDetailScreen;
